import store from '../store/store';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';

export default function isConsumer(): boolean {
    return store.userConfiguration.SessionSettings.WebSessionType !== WebSessionType.Business;
}
